import type { BrandEnvironment } from '@comparit/infrastructure';

interface MlpEnvironment extends BrandEnvironment {
  registrationUrl: string;
  passwordResetUrl: string;
  logoutUrl: string;
}

export const mlpEnvironment: MlpEnvironment = {
  apiUrl: 'https://endkundenrechner-mlp-api.cpit.dev',
  portalUrl: 'https://mlptest.zeitsprung-makler.de/kundenportal/',
  registrationUrl: 'https://mlptest.zeitsprung-makler.de/kundenportal/registrierung_kunde.php',
  passwordResetUrl: 'https://mlptest.zeitsprung-makler.de/kundenportal/registrierung_vergessen.php',
  logoutUrl: 'https://mlptest.zeitsprung-makler.de/kundenportal/logout',
};
